import React from 'react';

const Footer = (props) =>{
    const { children = '' } = props;
    return(
      <footer {...props.attrFooter}> {children}</footer>
    );
};

export default Footer;